import React from 'react';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, ReferenceLine, Label } from 'recharts';
import {
    Stack,
    Card,
    CardContent,
    Typography,
    Pagination,
    Box,
} from '@mui/material';

const COLORS = ['#f1884bff','#5fb0dfff', '#ea6175ff', '#5fb0dfff'];

const DEFAULT_COLOR = '#88cee5ff';      // Blue for all bars
const HIGHLIGHT_COLOR = '#FF8042';    // Highlight color for your vehicle


const LEGENDS = [
  { label: '< 10%', color: '#f1884bff' },
  { label: '10–80%', color: '#5fb0dfff' },
  { label: '> 80%', color: '#ea6175ff' },
];

// Custom label renderer (percentage inside pie slices)
const renderCustomLabel = ({ percent, cx, cy, midAngle, innerRadius, outerRadius }) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={12}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export function CarPieChart({ data }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ResponsiveContainer width="60%" height={200}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={60}
            label={renderCustomLabel}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      {/* Static custom legend */}
      <div style={{ marginLeft: 2 }}>
        {LEGENDS.map((item, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
            <div
              style={{
                width: 12,
                height: 12,
                backgroundColor: item.color,
                marginRight: 8,
                borderRadius: 2,
              }}
            />
            <span style={{ fontSize: 12 }}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}


export const Battery = ({ capacity, soh }) => {

  const batteryLevel = Math.min(Math.max(soh, 0), 100);
  const newbattery = ((capacity*soh)/ 100).toFixed(2);
  const miles = Math.round((304*soh)/ 100); 
  
  // Color based on level
  let color = '#5fb0dfff';
  if (batteryLevel < 20) color = 'red';
  else if (batteryLevel < 50) color = 'orange';

 
  return (
    

    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: 10, marginTop: 20 }}>
      {/* Text next to battery */}
      <div style={{ fontSize: '25px', fontWeight: 'bold', marginLeft: "20px" }}>
        {soh}%
      </div>
      {/* Battery */}
      <div style={{
        width: '30px',
        height: '70px',
        borderRadius: '2px',
        position: 'relative',
        backgroundColor: '#5cce0aff',
      }}>
        {/* Battery fill */}
        <div style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          height: `${batteryLevel}%`,
          backgroundColor: color,
          borderRadius: '0 0 2px 2px',
          transition: 'height 0.3s ease-in-out',
        }} />
      </div>

      {/* Text next to battery */}
      <div style={{ fontSize: '10px' }}>
        This battery: <br />
        {newbattery} kWh / {miles} miles <br /> <br />
        <div style={{ fontSize: '10px' }}>
        New Battery: <br />
         {capacity} kWh / 304 miles 
        </div>
      </div>
    </div>
  );
};

